import { SVGProps } from 'react';

const SvgCap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g clipPath="url(#CAP_svg__a)">
      <path
        fill="#FC3"
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
      />
      <path
        fill="#FFDE83"
        d="M20.288 13.024c-1.468 4.768-3.832 10.584-9.108 13.268a22 22 0 0 1-5.48 1.952c.74.624 1.54 1.18 2.384 1.664a24.7 24.7 0 0 0 4.096-1.648c2.112-1.072 3.88-2.56 5.404-4.54 1.924-2.496 3.496-5.78 4.808-10.044A254.284 254.284 0 0 0 25.4 3.064c-.62-.452-1.276-.86-1.96-1.22-.856 3.268-1.788 6.748-3.156 11.184l.004-.004Z"
      />
      <path
        fill="#FFE9AB"
        d="M17.688 13.988c1.456-4.356 2.68-8.712 3.804-13.02a15.714 15.714 0 0 0-2.12-.608c-1.116 4.284-2.332 8.616-3.776 12.928-.816 2.44-2.424 5.84-5.456 8.2-2.368 1.844-4.888 2.796-7.768 2.9a16.33 16.33 0 0 0 1.532 2.084c2.76-.352 5.256-1.428 7.592-3.244 3.464-2.696 5.28-6.512 6.192-9.24Z"
      />
      <path
        fill="#FB3"
        d="M23.337 23.1a1.102 1.102 0 0 0-1.948-1.028c-2.26 4.288-5.592 7.408-9.909 9.276a15.96 15.96 0 0 0 3.596.624c3.485-2.096 6.256-5.068 8.26-8.872ZM23.72 19.636a1.107 1.107 0 0 0 1.408-.668 214.983 214.983 0 0 0 3.944-12.184 16.025 16.025 0 0 0-1.708-2.04 213.304 213.304 0 0 1-4.316 13.484 1.104 1.104 0 0 0 .668 1.408h.004Z"
      />
      <path
        fill="#FFD45C"
        d="M7.5 20.76c3.756-2.284 5.416-6.56 6.68-10.388A165.914 165.914 0 0 0 17.212.052C16.812.02 16.408 0 16 0c-.356 0-.708.016-1.06.04a164.74 164.74 0 0 1-2.852 9.64c-1.14 3.456-2.62 7.3-5.732 9.196-1.62.984-3.64 1.372-5.852 1.12.2.78.46 1.54.772 2.268 2.308.092 4.444-.42 6.228-1.504H7.5Z"
      />
      <path
        fill="#FFDE83"
        d="M3.376 17.556c2.408-.588 4.272-2.44 5.54-5.5 1.132-2.736 2.188-5.876 2.828-8.4a1.104 1.104 0 0 0-2.14-.54c-.612 2.424-1.632 5.452-2.728 8.096C5.892 13.588 4.54 15 2.852 15.416c-.976.24-1.948.2-2.836.024-.008.188-.016.376-.016.564 0 .568.032 1.128.088 1.684.452.064.9.1 1.34.1a8.21 8.21 0 0 0 1.944-.228l.004-.004Z"
      />
    </g>
    <defs>
      <clipPath id="CAP_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCap;
